import { useState, useEffect, useCallback } from "react"
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import axios from "../axios";

import { getQueries } from "../utils/util";

import { isEmpty } from "lodash";

const localList = ({
  page = 0,
  rowsPerPage = 5,
  sort,
  sortOrder,
  searchTerm,
  searchFields,
  list = [],
  localFilters = {}
}) => {
  const term = searchTerm?.trim().toLowerCase();
  const activeFilters = Object.entries(localFilters ?? {}).filter(
    ([, val]) => val !== '' && val != null
  );

  let filtered = list.filter(el => {
    if (!term && !activeFilters.length) return true;

    const matchesSearch =
      !term ||
      searchFields.some(field => {
        const value = el[field];
        return value != null && String(value).toLowerCase().includes(term);
      });

    const matchesFilters = activeFilters.every(
      ([key, val]) => String(el[key]) === String(val)
    );

    return matchesSearch && matchesFilters;
  });

  console.log(filtered, "filtered");

  if (sort) {
    filtered = filtered.sort((a, b) => {
      if (a[sort] < b[sort]) {
        return sortOrder === 'asc' ? -1 : 1;
      }
      if (a[sort] > b[sort]) {
        return sortOrder === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }

  filtered = filtered.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return {rows: filtered, pages: list.length};
}

const useSimpleTable = ({ defaultSort = '-date', rowsPerPage = 5, url, tabs, tabField, localData, searchFields = [], filterString = '', enabled = true }) => {
  const [pagination, setPagination] = useState({
    page: 0,
    rowsPerPage
  });

  const [sort, setSort] = useState(defaultSort);

  const [query, setQuery] = useState({

  });

  const [localFilters, setLocalFilters] = useState({});

  // mainly for local data, if it is provided
  const [searchTerm, setSearchTerm] = useState('');

  let urlKey = url ? url.split('/')[1] : '';

  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: [urlKey, pagination, sort, query, searchTerm, localData, filterString, localFilters], 
    queryFn: () => load(),
    placeholderData: keepPreviousData,
    // keepPreviousData: true,
    enabled
  });

  const handleTabs = (tab, isCustom) => {
    const tabId = tabs[tab]?.id;
    if (!tabId) {
      return;
    }
    setQuery((prevQuery) => {
      const newQuery = { ...prevQuery };
      newQuery.tab = {[tabField]: tabId};
      if (isCustom) {
        newQuery.custom = true;
      } else {
        delete newQuery.custom;
      }
      return newQuery;
    });
  };

  const handleSort = (id) => {
    setSort(os => {
      if (!os) return id;

      let osOpts = os.split("-");
      let sortDir = osOpts.length > 1 ? 'desc' : 'asc';
      let field = osOpts[0] || osOpts[1]
      if (id === field) {
        return sortDir === 'desc' ? `${id}` : `-${id}`
      } else {
        return id;
      }
    })
  }

  const constructQuery = (url) => {
    let queryString = `?sort=${sort}&page=${pagination.page}&limit=${pagination.rowsPerPage}`;
    let additionalQueries = getQueries(query);
    queryString += additionalQueries;
    queryString += filterString || "";
    return `${url}${queryString}`;
  }

  const load = async () => {
    try {
      if (localData?.length) {
        return localList({
          page: pagination.page,
          rowsPerPage: pagination.rowsPerPage,
          sort,
          sortOrder: sort[0] === '-' ? 'desc' : 'asc',
          searchTerm,
          searchFields,
          list: localData,
          localFilters
        });
      }
      if (!url) {
        return {rows: [], pages: 2000};
      }
      let final_url = constructQuery(url);
      const { data } = await axios.get(final_url);
      return data;
    } catch (e) {
      return {rows: [], pages: 2000};
    }
  }

  return { query, pagination, setPagination, 
    handleTabs, handleSort, data, sort, isLoading, isError, error, setSearchTerm, searchTerm, setLocalFilters, localFilters, refetch 
   };

};

export default useSimpleTable;